<template>

  <a :title="'حذف'" href="javascript:void(0);" class="dropdown-item dots-options"
          @click.prevent="deleteData(data, deleteUrl)"><i class="flaticon-delete-2"></i> حذف</a>
</template>

<script>
import baseApi from '@/baseApi'

export default {
  components: {},
  props: {
    deleteUrl: String,
    data: Object
  },
  methods: {
    deleteData(data, deleteUrl) {
      let vm = this.$root;
      vm.swal.fire({
        title: "هل انت متأكد ؟",
        text: "البيانات المحذوفة لا يمكن استرجها",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: "لا",
        confirmButtonText: "نعم"
      }).then((result) => {
          if (result.value) {
            baseApi().delete(deleteUrl).then((response) => {
              if (response.data.code === 200) {
                this.$emit('deleteData', data);
                this.sweetAlert('تمت عملية الحذف بنجاح')
              }
            }).catch( (response) => {
              const errors = JSON.parse(JSON.stringify(response.response.data.errors));
              for (const error in errors) {
                this.sweetAlert(errors[error], 'warning')
              }
            });
          }
        }).catch(() => {});
    }
  },
  computed:{
    trans(){
      return this.$store.getters.GET_TRANS;
    },
  }
}
</script>




